<template>
  <el-dialog width="860px" :visible.sync="dialogVisible" @close="$emit('update:visible',false)">
    <div class="istitle" slot="title">
      <span class="whd-hand" :class="showNext?'':'on'" @click="onShowNext(0)">选择员工</span> - 
      <span class="whd-hand" :class="showNext?'on':''" @click="onShowNext(1)">选择数量</span>
    </div>
    <div class="weui-cell" style="align-items: flex-start">
      <div class="weui-cell__hd" style="margin-right: 20px" v-if="!showNext">
        <div class="tree_filter">
          <el-input placeholder="输入关键字进行过滤" v-model="filterText" size="small">
            <el-button slot="append" icon="el-icon-search" @click="filterkeyword" size="small"></el-button>
          </el-input>
        </div>
        <div class="search_result" v-if="!treeflag">
          <p>共有 {{count}}个搜索结果</p>
          <ul class="treelist">
            <li v-for="(item,index) in result" :key="index" @click="handleNode(item)">{{item.name}}</li>
          </ul>
        </div>
        <el-tree v-if="treeflag" class="filter-tree" default-expand-all :props="props" :load="loadNode" lazy ref="tree"
            @node-click="handleNode"
        >
          <span class="custom-tree-node" slot-scope="{ node }">
            <div class="tree_title">
              <div class="tree_label">{{ node.label }}</div>
            </div>
          </span>
        </el-tree>
      </div>
      <div class="weui-cell__bd">
        <div class="table_wrap" style="max-height: auto !important">
          <el-table v-if="showNext" key="next" :data="selectData" height="320" style="width: 100%">
            <el-table-column label="头像">
              <template slot-scope="scope">
                <div class="td_img">
                  <img :src="scope.row.pic"  />
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="name" label="昵称"></el-table-column>
            <el-table-column prop="position" label="职务"></el-table-column>
            <el-table-column prop="num" label="数量">
              <template slot-scope="scope">
                <div class="el-input-number el-input-number--mini">
                  <span role="button" class="el-input-number__decrease" @click="onDescrease(scope.$index, scope.row.num - 1)"><i class="el-icon-minus"></i></span>
                  <span role="button" class="el-input-number__increase" @click="onIncrease(scope.$index, scope.row.num + 1)"><i class="el-icon-plus"></i></span>
                  <div class="el-input el-input--mini">
                    <input type="number" v-model="scope.row.num" autocomplete="off" class="el-input__inner" @input="onChangeInput(scope.$index, scope.row.num)" />
                  </div>
                </div>
              </template>
            </el-table-column>
          </el-table>  
   
          <el-table v-if="!showNext" key="prev" :data="tableData" height="320" style="width: 100%" @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column label="头像">
              <template slot-scope="scope">
                <div class="td_img">
                  <img :src="scope.row.pic" alt/>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="name" label="昵称"></el-table-column>
            <el-table-column prop="position" label="职务"></el-table-column>
          </el-table>          
          <div v-if="!showNext" class="pag_wrap" style="margin: 10px auto 0;">
            <el-pagination
                background
                @current-change="pageIndexChange"
                :page-size="page.pagesize"
                :current-page="page.pageindex"
                layout="total, prev, pager, next"
                :total="page.total"
            ></el-pagination>
          </div> 
                        
        </div>        
      </div>
    </div>
    <div slot="footer" class="dialog-footer">    
      <span class="mr10 whd-gray666" v-if="showNext && send_type==1">共<strong class="whd-gray333">{{totalNumber}}</strong>张，还可分发<strong class="whd-gray333">{{remain}}</strong>张</span>
      <span class="mr10 whd-gray666" v-if="showNext && send_type==0">共<strong class="whd-gray333">{{totalNumber}}</strong>张，每人平均分发<strong class="whd-gray333">{{num}}</strong>张，还有<strong class="whd-gray333">{{remain}}</strong>张可自定义分发</span>
      <el-button class="ml10" @click="dialogVisible = false">取 消</el-button>
      <el-button v-if="!showNext" type="primary" @click="onNext">下一步</el-button>
      <el-button v-else type="primary" @click="onSubmit">提 交</el-button>
    </div>
  </el-dialog>  
</template>

<script>
import api from "@/api.js";
import {pagination} from "@/util/util.js";
export default {
  name: 'selectEmployeeDialog',
  props: ["visible", "send_type", "totalNumber"],
  watch: {
    visible() {
      this.dialogVisible = this.visible;
      console.log(this.totalNumber, this.selectData)
    }
  },
  data() {
    return {
      dialogVisible: this.visible,
      filterText: '',
      count: '',
      result: [],
      treeflag: true,
      props: {
        label: "name",
        children: "zones",
        isLeaf: "leaf"
      },
      formdata: {
        name: "",
        depart_id: ""
      },
      tableData: [],
      selectData: [],
      page: {
        pageindex: pagination.pageIndex,
        pagesize: pagination.pageSize,
        total: pagination.total
      },
      showNext: false,
      num: '',
      remain: ''    
    };
  },
  created() {
    this.init();
  },
  methods: {
    // 关键字查询
    filterkeyword() {
      if (this.filterText == "") {
        this.treeflag = true;
      } else {
        this.formdata.depart_id = "";
        this.treeflag = false;
        let params = {
          name: this.filterText
        };
        this.axios
            .post(api.department_searchs, params)
            .then(response => {
              if (response.data.code == 0) {
                this.count = response.data.count;
                this.result = response.data.list || [];
              } 
            })
            .catch(response => {
            });
      }
    },
    pageIndexChange(pageindex) {
      this.page.pageindex = pageindex;
      this.queryemployee();
    },
    // 懒加载
    async loadNode(node, resolve) {
      if (node.level === 0 || node.level === 1) {
        let res = await this.querydep();
        if (res && res.data.code === 0) {
          if (node.level === 0) {
            return resolve([
              {name: res.data.info.name, id: res.data.info.id}
            ]);
          } else {
            let deplist = res.data.info.list || [];
            return resolve(deplist);
          }
        } else {
          return resolve([]);
        }
      }
      if (node.level > 1) {
        let id = node.data.id;
        let childres = await this.querychilddep(id);
        if (childres && childres.data.code === 0) {
          let childdep = childres.data.list || [];
          return resolve(childdep);
        } else {
          return resolve([]);
        }
      }
    },
    // 查询部门
    querydep() {
      let params = {};
      return this.axios.post(api.department_index, params);
    },
    // 查询子部门
    querychilddep(id) {
      let params = {
        depart_id: id
      };
      return this.axios.post(api.department_getchild, params);
    },
    handleNode(data) {
      this.formdata.depart_id = data.id;
      this.search();
    },
    // 搜索
    search() {
      this.init();
    },
    //初始化请求
    init() {
      this.page.pageindex = 1;
      this.queryemployee();
    },

    // 查询员工
    queryemployee() {
      let params = {
        page: this.page.pageindex,
        name: this.formdata.name,
        depart_id: this.formdata.depart_id
      };
      this.axios
          .post(api.employee_index, params)
          .then(response => {
            if (response.data.code == 0) {
              this.tableData = response.data.list;
              this.page.total = response.data.all_page;
              let switch_structure = false;
              if (response.data.switch_structure === 1) {
                switch_structure = true;
              }
              this.switch_structure = switch_structure;
              this.page.total = response.data.all_page;
              this.app_admin = response.data.app_admin
            } else {
              this.page.total = 0;
            }
          })
          .catch(response => {
          });
    },
    // 选项
    handleSelectionChange(val) {
      this.selectData = val;
    },
    onNext() {
      if (this.selectData.length == 0) {
        this.$message.warning('请选择员工');
        return
      }
      this.num = parseInt(this.totalNumber / this.selectData.length);
      if (this.send_type == 0) {
        this.remain = this.totalNumber - (parseInt(this.totalNumber / this.selectData.length) * this.selectData.length);
      } else {
        this.remain = this.totalNumber;
      }
      let arr = [];
      let num = 0;
      if (this.send_type == 0) {
        num = this.num;
      }
      this.selectData.forEach(item => {
        item.num = num;
        arr.push(item);
      })   
      this.selectData = arr;   
      this.showNext = true;
    },
    onShowNext(option) {
      if (option === 0) {
        this.showNext = false;
        this.selectData = [];
      } else {
        if (this.selectData.length == 0) {
          this.$message.warning('请选择员工');
          return
        }
        this.showNext = true;
      }
    },
    onDescrease(index, num) {
      if (num >= 0) {
        const item = this.selectData[index];
        item.num = num;
        this.$set(this.selectData, index, item);
        this.remain++;
      }
    },
    onIncrease(index, num) {
      if (this.remain == 0) {
        this.$message.warning('卡券数量已全部分配');
        return
      }
      const item = this.selectData[index];
      item.num = num;
      this.$set(this.selectData, index, item);
      this.remain--;
    },
    onChangeInput(index, num) {
      let total = 0;
      this.selectData.forEach((item, i) => {
        if (i !== index) {
          total = total + parseInt(item.num);
        }
      })
      if (parseInt(num)) {
        if (total + parseInt(num) > this.totalNumber) {
          const obj = this.selectData[index];
          obj.num = this.totalNumber - total;
          this.$set(this.selectData, index, obj);
          this.remain = 0;
        } else {
          this.remain = this.totalNumber - total - parseInt(num);
        }
      } else {
        this.remain = this.totalNumber - total;
      }
    },
    // 提交
    onSubmit() {
      if (this.selectData.length > 0) {
        let brr = [];
        this.selectData.forEach(item => {
          brr.push({eid: item.id, name: item.name, num: item.num});
        })
        this.$emit('selectDataBack', brr);
        this.dialogVisible = false;
      } else {
        this.$emit('selectDataBack');
        this.dialogVisible = false;
      }
    }
  }
}
</script>

<style scoped>
.istitle span{line-height: 24px; vertical-align: middle;}
.istitle .on{font-weight: bold; font-size: 20px;}
</style>